export const FORUM_RENAME_STARTED = 'settings/FORUM_RENAME_STARTED';
export const forumRenameStarted = () => ({
  type: FORUM_RENAME_STARTED,
});



// WEBPACK FOOTER //
// ./app-settings/actions/forum-rename-started.js